var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"organization-dashboard"},[_c('div',{staticClass:"metrics-grid"},_vm._l((_setup.metrics),function(metric){return _c(_setup.OrganizationalMetric,{key:metric.id,attrs:{"count":metric.count,"value":metric.value}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }